<template>
  <div
    class="l-learn-video l-border l-learn-content-container"
    :class="{
      'hide-play-btn': options ? !!options.hidePlayBtn : false,
      'btn-play-disable':
        options && !options.canstop
          ? true
          : element && leftCount <= 0,
    }"
  >
    <!-- 播放器 -->
    <div id="aliplayer"></div>
    <!-- 视频剩余暂停次数 -->
    <div class="l-pause-num" v-if="options.canstop && showPauseNumberBar">剩余暂停次数：{{ leftCount }}次</div>
    <slot class="name"></slot>
    <!-- 播放/暂停按钮 -->
    <div class="l-play-btn-mask" v-if="isShow">
      <img src="./images/l-play.png" class="l-big-play-btn" @click="onPlay" alt />
    </div>
  </div>
</template>

<script>
import version from '@/utils/version'
import aliplayer from '@/utils/aliplayer'
import UserModel from '@/models/usercenter'
import TIP from '@/constants/tip'
import elementTypes from '../../minxin/elementTypes'
import { createNamespacedHelpers } from 'vuex'
import { recordStudyPlayData } from '@/utils/record'

const { mapGetters, mapActions } = createNamespacedHelpers('course')
const user = new UserModel()

export default {
  props: {
    /**
     *  vid:视频vid
     *  autoplay: 是否自动播放;默认 false
     *  canstop: 是否可暂停;默认 true
     *  hidePlayBtn: 是否隐藏播放按钮;默认 false
     */
    options: {
      type: Object,
      default: () => {
        return {
          autoplay: false,
          control: true,
          hidePlayBtn: false,
          canstop: true,
          isEnded: false, // 播放完成
        }
      },
    },
  },
  mixins: [elementTypes],
  data() {
    return {
      player: null,
      params: {},
      mark: '',
      isShow: true,
      showPauseNumberBar: false, // 是否展示剩余次数栏
      waterMarker: {},
      videoData: {},
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  computed: {
    ...mapGetters(['element']),
    // 剩余暂停次数
    leftCount() {
      return this.element && this.element.attrs
        ? this.element.attrs.onceStopNum - this.element.pause
        : ''
    },
  },
  async created() {
    await this._mark()
  },
  watch: {
    'element.isSubmit'(to) {
      if (to && this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.VIDEO) {
        localStorage.removeItem(this.player.LOCK_KEY)
      }
    },
    async 'element.isCallBack'() {
      // 不是播放状态 直接返回
      if (this.player) {
        // 当前播放状态不是正在播放,可以返回
        console.log('点击了返回', this.player.getStatus())

        if (this.player.getStatus() === 'pause') {
          this.$emit('back')
          return
        }

        // ABC讲解的答案视频不需要减暂停次数
        if (this.element.ELEMENT_TYPE == this.ELEMENT_TYPES.ABC_EXPLAIN_TEST) {
          if (
            this.$parent.stage === this.$parent.STAGE_TYPES.isPlayAnswerVideo
          ) {
            this.$emit('back')
            return
          }
        }

        // 扩听故事答案视频不需要减暂停次数
        if (this.element.ELEMENT_TYPE == this.ELEMENT_TYPES.EXPLAIN_TEST) {
          if (
            this.$parent.stage === this.$parent.STAGE_TYPES.isPlayAnswerVideo
          ) {
            this.$emit('back')
            return
          }
        }

        // 没有剩余暂停次数，不能返回
        if (this.leftCount <= 0) {
          this.$lToast(TIP.NO_PAUSE)
          return
        }

        // 先减暂停次数
        let isPause = await this.STUDY_MEDIA_PAUSE({
          elementId: this.element.id,
        })

        if (isPause) {
          console.log('返回使用了暂停次数')
          this._stopClick()
          this.$emit('back')
        }
      }
    },
    options: {
      deep: true, // 深度监听
      handler(newVal, oldVal) {
        if (newVal.vid != oldVal.vid) {
          this.player ? this.player.dispose() : null
          this._initPlayer()
        }
      },
    },
  },
  methods: {
    ...mapActions(['STUDY_MEDIA_PAUSE']),
    onFullScreenClick() {
      let full_screen = document.querySelector('#full_screen')
      full_screen.onclick()
    },
    onFullScreen() {
      if (!this.player.fullscreenService.getIsFullScreen()) {
        try {
          this.player.fullscreenService.requestFullScreen()
        } catch (error) {
          console.log('尝试全屏失败')
        }
      }
    },
    onPlay() {
      this.player.play()
      let time = localStorage.getItem(`VIDEO_TIME_${this.element.RECORD_ID}`)
      if (!version.isPC() && time) {
        this.player.seek(Number(time))
      }
    },
    onPlayEnd() {
      this.player ? this.player.pause() : null
    },
    //设置播放器音量
    setVolume(volume) {
      this.player.setVolume(volume)
    },
    dispose() {
      this.player.dispose()
    },
    async _mark() {
      let res = await user.phone()

      this.mark = res.data.phone
      if (this.options) {
        this._initPlayer()
      }
    },
    _toggleContrlBar(b) {
      this.showPauseNumberBar = b
    },
    // 设置暂停次数
    _setpauseNumber() {
      if (this.leftCount === 0) {
        this.player.play()
        return
      }

      let res = this.STUDY_MEDIA_PAUSE({
        elementId: this.element.id,
      })
      if (res) {
        console.log('手动暂停，使用了暂停次数')
        this._stopClick()
      }
    },
    _initPlayer() {
      console.log('初始化播放器')
      aliplayer({
        ...(this.options || this.params),
        mark: this.mark,
        selector: 'aliplayer',
        currentKeyValue: `VIDEO_TIME_${this.element.RECORD_ID}`,
      }).then((player) => {
        this.player = player

        this._initEvent()
      })
    },
    _stopClick() {
      if (!this.options.canstop || this.leftCount === 0) {
        var span = document.createElement('span')
        span.className = 'mask'
        span.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
        })
        document.querySelector('.prism-play-btn').appendChild(span)
      }
    },
    // 绑定事件
    _initEvent() {
      this._stopClick()
      this.player.on('ready', () => {
        console.log('视频已准备')

        this.$emit('ready', {
          duration: this.player.getDuration()
            ? this.player.getDuration()
            : this.player.videoTotalTime,
          volume: this.player.getVolume(),
        })
      })
      // 绑定事件
      this.player.on('play', () => {
        if (this.playTimer) {
          clearInterval(this.playTimer)
        }
        this._countTime()
        console.log('播放视频')
        if (this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.VIDEO) {
          if (version.isPC()) {
            this.onFullScreenClick()
          } else {
            this.onFullScreenClick()
          }
        }
        this.isShow = false
        this.$emit('play')
        this._stopClick()
      })

      // 播放结束
      this.player.on('pause', () => {
        console.log('播放暂停')
        clearInterval(this.playTimer)

        this.isShow = true
        if (
          this.showPauseNumberBar &&
          (this.player.getStatus() !== 'ended' ||
            this.player.getStatus() !== 'playing') &&
          !this.isEnded
        ) {
          console.log('点击暂停')
          this._setpauseNumber()
        }
        //自读跟读暂停
        if (
          (this.element.ELEMENT_TYPE == this.ELEMENT_TYPES.SELF_READING_TEST ||
            this.element.ELEMENT_TYPE ==
              this.ELEMENT_TYPES.LISTEN_REPEAT_TEST) &&
          this.player.fullscreenService.getIsFullScreen()
        ) {
          this.player.fullscreenService.cancelFullScreen()
        }
        this.$emit('pause')
      })

      // 播放结束
      this.player.on('ended', async () => {
        console.log('播放结束')
        clearInterval(this.playTimer)
        recordStudyPlayData({
          id: this.element.id,
          bizType: this.element.type,
          type: 1,
          offset: this.playTime,
        }, this.element.ELEMENT_TYPE)

        this.isEnded = true
        // 退出全屏
        if (this.player.fullscreenService.getIsFullScreen()) {
          await this.player.fullscreenService.cancelFullScreen()
        }
        if (!version.isPC()) {
          let learnVideo = document.querySelector('.l-learn-video')
          if (learnVideo.className.indexOf('isfullScreen') > -1) {
            this.onFullScreenClick()
          }
        }
        if (this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.VIDEO) {
          this.$emit('submit')
          return
        }
        this.$emit('ended')
      })

      // 控制栏展示
      this.player.on('showBar', () => {
        this._toggleContrlBar(true)
      })
      // 控制栏展示
      this.player.on('hideBar', () => {
        this._toggleContrlBar(false)
      })
      this.player.on('timeupdate', () => {
        if (
          this.player.getCurrentTime() >=
          (this.player.getDuration()
            ? this.player.getDuration()
            : this.player.videoTotalTime)
        ) {
          this.isEnded = true
        }
        if (
          this.player.getStatus() !== 'ended' &&
          this.player.getStatus() !== 'init' &&
          this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.VIDEO &&
          !this.isEnded
        ) {
          localStorage.setItem(
            this.player.LOCK_KEY,
            this.player.getCurrentTime()
          )
        }
        this.$emit('update', {
          currentTime: this.player.getCurrentTime(),
        })
      })

      document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
          this.$emit('leavingFull', false)
        } else {
          this.$emit('leavingFull', true)
        }
      })
    },

    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },
  },
  mounted() {
    setTimeout(() => {
      // 对sdk自带的全屏按钮进行隐藏
      let full_screen_btn = document.querySelector('.prism-fullscreen-btn')
      full_screen_btn.style.display = 'none'
    }, 1000)
  },
  destroyed() {
    this.dispose()
    recordStudyPlayData({
      id: this.element.id,
      bizType: this.element.type,
      type: 1,
      offset: this.playTime,
    }, this.element.ELEMENT_TYPE)
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
@import 'https://g.alicdn.com/de/prismplayer/2.9.8/skins/default/aliplayer-min.css'
</style>
